// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import SafetyAnchorPointResourceViewModel from '../../../../viewModel/resource/SafetyAnchorPointResourceViewModel';
import SafetyAnchorPointResourceDTO from '../../dto/resource/SafetyAnchorPointResourceDTO';

export default abstract class SafetyAnchorPointResourceModel extends BaseModel<SafetyAnchorPointResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  * @type {int64}
  */
  get siHaDocumentationId() { return this.dto.siHaDocumentationId; }
  set siHaDocumentationId(value) { this.dto.siHaDocumentationId = value; }
  /**
  * @type {int64}
  */
  get safetyHookId() { return this.dto.safetyHookId; }
  set safetyHookId(value) { this.dto.safetyHookId = value; }
  /**
  */
  get name() { return this.dto.name; }
  set name(value) { this.dto.name = value; }
  /**
  * @type {int32}
  */
  get screwLength() { return this.dto.screwLength; }
  set screwLength(value) { this.dto.screwLength = value; }
  /**
  */
  get remark() { return this.dto.remark; }
  set remark(value) { this.dto.remark = value; }
  /**
  */
  get isInstalledOnCounterBatten() { return this.dto.isInstalledOnCounterBatten; }
  set isInstalledOnCounterBatten(value) { this.dto.isInstalledOnCounterBatten = value; }
  /**
  */
  get installationRemark() { return this.dto.installationRemark; }
  set installationRemark(value) { this.dto.installationRemark = value; }
  /**
  * @type {date-time}
  */
  get installationDate() { return this.dto.installationDate; }
  set installationDate(value) { this.dto.installationDate = value; }
  /**
  */
  get isDocumentationCompleted() { return this.dto.isDocumentationCompleted; }
  set isDocumentationCompleted(value) { this.dto.isDocumentationCompleted = value; }
  /**
  * @type {int64}
  */
  get previousSafetyAnchorPointId() { return this.dto.previousSafetyAnchorPointId; }
  set previousSafetyAnchorPointId(value) { this.dto.previousSafetyAnchorPointId = value; }
  /**
  * @type {int64}
  */
  get nextSafetyAnchorPointId() { return this.dto.nextSafetyAnchorPointId; }
  set nextSafetyAnchorPointId(value) { this.dto.nextSafetyAnchorPointId = value; }
  /**
  */
  get documentationImage1ExternalId() { return this.dto.documentationImage1ExternalId; }
  set documentationImage1ExternalId(value) { this.dto.documentationImage1ExternalId = value; }
  /**
  */
  get documentationImage2ExternalId() { return this.dto.documentationImage2ExternalId; }
  set documentationImage2ExternalId(value) { this.dto.documentationImage2ExternalId = value; }
  /**
  */
  get documentationImage3ExternalId() { return this.dto.documentationImage3ExternalId; }
  set documentationImage3ExternalId(value) { this.dto.documentationImage3ExternalId = value; }
  /**
  */
  get documentationImage4ExternalId() { return this.dto.documentationImage4ExternalId; }
  set documentationImage4ExternalId(value) { this.dto.documentationImage4ExternalId = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    value = Number.parseFloat(qs.sihadocumentationid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.siHaDocumentationId = value;
    value = Number.parseFloat(qs.safetyhookid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.safetyHookId = value;
    this.dto.name = qs.name;
    value = Number.parseFloat(qs.screwlength);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.screwLength = value;
    this.dto.remark = qs.remark;
    value = qs.isInstalledOnCounterBatten === 'true' ? true : qs.isinstalledoncounterbatten;
    value = qs.isInstalledOnCounterBatten === 'false' ? false : undefined;
    this.dto.isInstalledOnCounterBatten = value;
    this.dto.installationRemark = qs.installationremark;
    this.dto.installationDate = qs.installationdate;
    value = qs.isDocumentationCompleted === 'true' ? true : qs.isdocumentationcompleted;
    value = qs.isDocumentationCompleted === 'false' ? false : undefined;
    this.dto.isDocumentationCompleted = value;
    value = Number.parseFloat(qs.previoussafetyanchorpointid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.previousSafetyAnchorPointId = value;
    value = Number.parseFloat(qs.nextsafetyanchorpointid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.nextSafetyAnchorPointId = value;
    this.dto.documentationImage1ExternalId = qs.documentationimage1externalid;
    this.dto.documentationImage2ExternalId = qs.documentationimage2externalid;
    this.dto.documentationImage3ExternalId = qs.documentationimage3externalid;
    this.dto.documentationImage4ExternalId = qs.documentationimage4externalid;
  }
}
